// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.credit-history-filter-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 20px;
    margin: 20px auto; 
    gap: 20px;
    background-color: #fff; 
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .credit-date-field {
    display: flex;
    flex-direction: column;
    width: 30%
  }
  
  .credit-date-field label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }
  
  .credit-date-field input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
  }

  .credit-form-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 15px 0 0;
  }
  
  .credit-form-actions .btn {
    padding: 8px 16px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .credit-form-actions .submit-btn {
    background-color: #44a67e;
    border-color: #44a67e;
  }
  
  .credit-form-actions .submit-btn:hover {
    background-color: #44a67e;
    border-color: #44a67e;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  
  .credit-form-actions .download-btn {
    background: #373435;
    color: #ffcc29;
  }
  
  .credit-form-actions .download-btn:hover {
    background: #373435;
    color: #ffcc29;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }


  /*Credit History Table Style  */
  .credit-history-table-container {
    width: 100%;
    overflow-x: auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  
  .credit-history-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .credit-history-table th,
  .credit-history-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .credit-history-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .credit-history-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .credit-history-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .credit-history-table td {
    color: #373435;
  }
  
  .credit-history-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }
  
  /* Expand Button */
  .credit-history-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .credit-history-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .credit-history-expanded-row {
    background-color: #eef7ff;
  }
  
  .credit-history-expanded-content {
    padding: 10px;
  }

  
  .wrap-credit-history {
    margin: 0 40px;
  }

@media (max-width: 768px) {
    .credit-history-filter-wrap {
        flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/CreditHistory/CreditHistory.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qFAAqF;EACvF;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qFAAqF;EACvF;;;EAGA,+BAA+B;EAC/B;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,cAAc;EAChB;;AAEF;IACI;QACI,sBAAsB;IAC1B;EACF","sourcesContent":["\r\n.credit-history-filter-wrap {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 25px 20px;\r\n    margin: 20px auto; \r\n    gap: 20px;\r\n    background-color: #fff; \r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .credit-date-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 30%\r\n  }\r\n  \r\n  .credit-date-field label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .credit-date-field input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n  }\r\n\r\n  .credit-form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    padding: 15px 0 0;\r\n  }\r\n  \r\n  .credit-form-actions .btn {\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .credit-form-actions .submit-btn {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n  }\r\n  \r\n  .credit-form-actions .submit-btn:hover {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n  .credit-form-actions .download-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n  }\r\n  \r\n  .credit-form-actions .download-btn:hover {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n\r\n  /*Credit History Table Style  */\r\n  .credit-history-table-container {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    margin-top: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n  }\r\n  \r\n  .credit-history-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .credit-history-table th,\r\n  .credit-history-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .credit-history-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .credit-history-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .credit-history-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .credit-history-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .credit-history-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n  \r\n  /* Expand Button */\r\n  .credit-history-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .credit-history-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .credit-history-expanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n  .credit-history-expanded-content {\r\n    padding: 10px;\r\n  }\r\n\r\n  \r\n  .wrap-credit-history {\r\n    margin: 0 40px;\r\n  }\r\n\r\n@media (max-width: 768px) {\r\n    .credit-history-filter-wrap {\r\n        flex-direction: column;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
